<template>
  <a-spin :spinning="confirmLoading">
    <j-form-container :disabled="formDisabled">
      <a-form :form="form" slot="detail">
        <a-row>
          <a-col :span="24">
            <a-form-item :label="$t('推送账号')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['sendCode']" :placeholder="$t('请输入推送账号')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('推送类型')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('请输入推送类型')" v-decorator="['sendType']" @change="handleChange">
                <a-select-option :value="0">
                  {{ $t('短信') }}
                </a-select-option>
                <a-select-option :value="1">
                  {{ $t('微信') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('设备类型')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('请输入设备类型')" v-decorator="['deviceType']">
                <a-select-option :value="0">
                  {{ $t('水表') }}
                </a-select-option>
                <a-select-option :value="1">
                  {{ $t('水质监测') }}
                </a-select-option>
                <a-select-option :value="2">
                  {{ $t('压力液位') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('激活状态')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('请输入激活状态')" v-decorator="['sendActive']">
                <a-select-option :value="0">
                  {{ $t('未激活') }}
                </a-select-option>
                <a-select-option :value="1">
                  {{ $t('激活') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('上级领导')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['top1']" :placeholder="$t('请输入上级领导账号')"></a-input>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('故障类型')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select :placeholder="$t('请选择故障类型')" v-decorator="['top2']">
                <a-select-option :value="0">
                  {{ $t('逆流故障') }}
                </a-select-option>
                <a-select-option :value="2">
                  {{ $t('存储故障') }}
                </a-select-option>
                <a-select-option :value="3">
                  {{ $t('电池欠压') }}
                </a-select-option>
                <a-select-option :value="4">
                  {{ $t('阀门开故障') }}
                </a-select-option>
                <a-select-option :value="5">
                  {{ $t('阀门关故障') }}
                </a-select-option>
                <a-select-option :value="6">
                  {{ $t('有磁干扰') }}
                </a-select-option>
                <a-select-option :value="6">
                  {{ $t('阀门锈死故障') }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="24">
            <a-form-item :label="$t('备注')" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['remark']" :placeholder="$t('请输入备注')"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </j-form-container>
    <a-modal v-model="visibles" :title="$t('请关注微信公众号')">
      <template slot="footer">
        <a-button key="close" @click="handleCancel">
          {{ $t('关闭') }}
        </a-button>
      </template>
      <img class="img" src="../../../assets/gzh.png" />
    </a-modal>
  </a-spin>
</template>

<script>

  import { httpAction, getAction } from '@/api/manage'
  import pick from 'lodash.pick'
  import { validateDuplicateValue } from '@/utils/util'
  import JFormContainer from '@/components/jeecg/JFormContainer'
  import JDate from '@/components/jeecg/JDate'  

  export default {
    name: 'WqMessageRevPersonForm',
    components: {
      JFormContainer,
      JDate,
    },
    props: {
      //流程表单data
      formData: {
        type: Object,
        default: ()=>{},
        required: false
      },
      //表单模式：true流程表单 false普通表单
      formBpm: {
        type: Boolean,
        default: false,
        required: false
      },
      //表单禁用
      disabled: {
        type: Boolean,
        default: false,
        required: false
      }
    },
    data () {
      return {
        form: this.$form.createForm(this),
        model: {},
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 },
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 },
        },
        confirmLoading: false,
        validatorRules: {
        },
        url: {
          add: "/wq/wQMessageRevPerson/add",
          edit: "/wq/wQMessageRevPerson/edit",
          queryById: "/wq/wQMessageRevPerson/queryById"
        },
        visibles: false,
        titleImage:0,
      }
    },
    computed: {
      formDisabled(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return false
          }
          return true
        }
        return this.disabled
      },
      showFlowSubmitButton(){
        if(this.formBpm===true){
          if(this.formData.disabled===false){
            return true
          }
        }
        return false
      }
    },
    created () {
      //如果是流程中表单，则需要加载流程表单data
      this.showFlowData();
    },
    methods: {
      add () {
        this.edit({});
      },
      edit (record) {
        this.form.resetFields();
        this.model = Object.assign({}, record);
        this.visible = true;
        this.$nextTick(() => {
          this.form.setFieldsValue(pick(this.model,'sendCode','sendType','deviceType','sendActive','remark'))
        })
      },
      //渲染流程表单数据
      showFlowData(){
        if(this.formBpm === true){
          let params = {id:this.formData.dataId};
          getAction(this.url.queryById,params).then((res)=>{
            if(res.success){
              this.edit(res.result);
            }
          });
        }
      },
      submitForm () {
        const that = this;
        // 触发表单验证
        this.form.validateFields((err, values) => {
          if (!err) {
            that.confirmLoading = true;
            let httpurl = '';
            let method = '';
            if(!this.model.id){
              httpurl+=this.url.add;
              method = 'post';
            }else{
              httpurl+=this.url.edit;
               method = 'put';
            }
            let formData = Object.assign(this.model, values);
            console.log("表单提交数据",formData)
            httpAction(httpurl,formData,method).then((res)=>{
              if(res.success){
                that.$message.success(res.message);
                setTimeout(() => {
                  that.$emit('ok');
                },400)
              }else{
                that.$message.warning(res.message);
              }
            }).finally(() => {
              that.confirmLoading = false;
            })
          }
         
        })
      },
      popupCallback(row){
        this.form.setFieldsValue(pick(row,'sendCode','sendType','deviceType','sendActive','remark','createBy','createTime','updateBy','updateTime'))
      },
      handleChange(value) {
        this.titleImage=value
        if (value==1) {
          this.visibles = true
        }
        console.log('出来呢')
      console.log(value); // { key: "lucy", label: "Lucy (101)" }
      },
      handleCancel () {
        this.visibles = false;
      }
    }
  }
</script>
<style scoped>
.img{
  width: 80%;
  height: 80%;
  vertical-align: middle;
  text-align: center;
  margin-left: 10%;
}
</style>